var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Error")]),_c('p',[_vm._v(_vm._s(_vm.data.message || 'Something went wrong'))]),_c('button',{on:{"click":_vm.close}},[_vm._v("OK")])])
}
var staticRenderFns = []

export { render, staticRenderFns }